import styled from '@emotion/styled'

const DetailsLabel = styled.div`
	${({ theme }) => `
	    font-size: 0.75rem;
        display: flex;
        align-items: center;
	    color: ${theme.palette.fonts.secondary};
    `}
`

const DetailsValue = styled.div`
	${({ theme }) => `
	    font-size: 0.875rem;
	    color: ${theme.palette.fonts.primary};
	    &:last-child {
	        padding-bottom: 0;
	    }

    `}
`

const DetailsValueIcon = styled.span`
	cursor: pointer;
	margin-left: 8px;
`

export { DetailsLabel, DetailsValue, DetailsValueIcon }
